import { FC, lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { LazyComponent } from '../features/lazy-component'

const Gallery = lazy(() => import('../__legacy__/components/gallery/Gallery'))

const GenesisListenPage: FC = () => (
  <LazyComponent>
    <Gallery />
  </LazyComponent>
)

export const GenesisListenRoute: RouteObject = {
  path: '/listen',
  element: <GenesisListenPage />
}
